import { isTurnActive } from "./global-loader";
import { useKitsChatSnapshot } from "./use-kits-chat";
import type { WagsAgentChatSnapshot } from "./wags-agent-chat";
import { isTriggerMessage, visibleText } from "../wags-ui-message";

export type ListingQuestionReply = {
    state: "pending" | "answered" | "failed";
    text: string;
};

export function listingQuestionReply(
    { messages, status }: Pick<WagsAgentChatSnapshot, "messages" | "status">,
    inputId: string,
): ListingQuestionReply {
    const questionIndex = messages.findIndex(
        (message) => message.metadata?.canonicalInputId === inputId,
    );
    if (questionIndex === -1) return { state: "pending", text: "" };

    const after = messages.slice(questionIndex + 1);
    const nextQuestion = after.findIndex(
        (message) => message.role === "user" && !isTriggerMessage(message),
    );
    const isLatestQuestion = nextQuestion === -1;
    const replies = (
        isLatestQuestion ? after : after.slice(0, nextQuestion)
    ).filter((message) => message.role === "assistant");
    const text = replies
        .map((message) =>
            message.parts.map(visibleText).filter(Boolean).join("\n\n"),
        )
        .filter(Boolean)
        .join("\n\n");

    const answered = replies.length > 0;
    if (!isLatestQuestion)
        return { state: answered ? "answered" : "failed", text };
    if (isTurnActive(status)) return { state: "pending", text };
    if (answered) return { state: "answered", text };
    return { state: status === "error" ? "failed" : "pending", text };
}

export function useListingQuestionReply(
    inputId: string | null,
): ListingQuestionReply | null {
    const snapshot = useKitsChatSnapshot(inputId !== null);
    return inputId ? listingQuestionReply(snapshot, inputId) : null;
}
